import "core-js/modules/es.array.concat.js";
import { BrowserCacheLocation, LogLevel } from "@azure/msal-browser";
export var generateMsalConfig = function generateMsalConfig(_ref) {
  var clientId = _ref.clientId,
      policies = _ref.policies,
      knownAuthorities = _ref.knownAuthorities,
      redirectUri = _ref.redirectUri,
      authorityBase = _ref.authorityBase;
  return {
    auth: {
      clientId: clientId,
      knownAuthorities: knownAuthorities,
      redirectUri: redirectUri,
      authority: "".concat(authorityBase, "/").concat(policies.signUpSignIn)
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      loggerOptions: {
        loggerCallback: function loggerCallback(level, message, containsPii) {
          if (containsPii) {
            return;
          }

          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;

            case LogLevel.Info:
              console.info(message);
              return;

            case LogLevel.Verbose:
              console.debug(message);
              return;

            case LogLevel.Warning:
              console.warn(message);
              return;

            default:
              return;
          }
        }
      }
    }
  };
};